import { ApiService } from '../../types/api';

export interface CubeApiContract {
  createJwt(siteId: string, siteEnv: string): Promise<string>;
}

declare module '../../context/page-context' {
  interface Apis {
    cube: CubeApiContract;
  }
}

/**
 * Mints the short-lived JWT analytics uses to talk to Cube directly.
 */
export class CubeApi extends ApiService implements CubeApiContract {
  public async createJwt(siteId: string, siteEnv: string): Promise<string> {
    const { token } = await this.api.fetch<{ token: string }>({
      method: 'POST',
      path: `/${encodeURIComponent(siteId)}/${encodeURIComponent(siteEnv)}/analytics/create-jwt`,
    });
    return token;
  }
}
